import { apiClient } from './apiClient';
import { PendingPayment, PendingPaymentStatus } from '../types/pendingPayment';

type ListParams = {
  status?: PendingPaymentStatus | 'all';
};

type PaginatedResponse<T> = {
  data: T[];
};

export async function listPendingPayments(token: string, params: ListParams = {}) {
  const query = new URLSearchParams();
  if (params.status && params.status !== 'all') {
    query.set('status', params.status);
  }

  const path = `/pending-payments${query.toString() ? `?${query.toString()}` : ''}`;

  return apiClient<PaginatedResponse<PendingPayment>>(path, {
    method: 'GET',
    token,
  });
}

export async function createPendingPayment(
  token: string,
  payload: {
    client_name: string;
    amount: number;
    due_date: string | null;
    status: PendingPaymentStatus;
    notes: string | null;
  },
) {
  return apiClient<{ data: PendingPayment }>(`/pending-payments`, {
    method: 'POST',
    token,
    body: JSON.stringify(payload),
  });
}

export async function updatePendingPayment(
  token: string,
  id: number,
  payload: Partial<Pick<PendingPayment, 'status' | 'received_on' | 'notes'>>,
) {
  return apiClient<{ data: PendingPayment }>(`/pending-payments/${id}`, {
    method: 'PUT',
    token,
    body: JSON.stringify(payload),
  });
}

export async function deletePendingPayment(token: string, id: number) {
  return apiClient<{ message: string }>(`/pending-payments/${id}`, {
    method: 'DELETE',
    token,
  });
}

export async function getPendingPaymentsTotal(token: string, status?: string) {
  const query = new URLSearchParams();
  if (status && status !== 'all') {
    query.set('status', status);
  }
  const path = `/pending-payments/total${query.toString() ? `?${query.toString()}` : ''}`;
  return apiClient<{ data: { total: string } }>(path, {
    method: 'GET',
    token,
  });
}

